import { createApp, App } from 'vue';
import { registerPlugins } from '@/plugins';
import i18n from '@/plugins/i18n';
import AppMain from '@/App.vue';

import '@/assets/scss/app.scss';

import 'simplebar';
import 'simplebar/dist/simplebar.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import { vMaska } from 'maska';

import 'maz-ui/css/main.css';

import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput';

import CountTo from '@/app/lib/CountTo.vue';
import ListMenu from '@/app/common/components/ListMenu.vue';
import ListMenuWithIcon from '@/app/common/components/ListMenuWithIcon.vue';
import Card from '@/app/common/components/Card.vue';
import Breadcrumb from '@/app/common/components/Breadcrumb.vue';
import TextField from '@/app/common/validationComponents/TextField.vue';
import TextArea from '@/app/common/validationComponents/TextArea.vue';
import Autocomplete from '@/app/common/validationComponents/Autocomplete.vue';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/msalConfig';

import * as Sentry from "@sentry/vue";
import router from '@/router';

const msalInstance = new PublicClientApplication(msalConfig);

const app: App = createApp(AppMain);
registerPlugins(app);

Sentry.init({
    app,
    environment: process.env.VITE_SENTRY_MODE || 'development',
    release: process.env.VITE_SENTRY_RELEASE || 'dev',
    debug: true,
    dsn: "https://e2a501d190d05d656b1abcb5efb128b1@sentry.caatdev.com/3",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

app.use(i18n);

app.component('CountTo', CountTo);
app.component('ListMenu', ListMenu);
app.component('Card', Card);
app.component('VueDatePicker', VueDatePicker);
app.component('ListMenuWithIcon', ListMenuWithIcon);
app.component('Breadcrumb', Breadcrumb);
app.component('TextField', TextField);
app.component('TextArea', TextArea);
app.component('Autocomplete', Autocomplete);
app.directive('maska', vMaska);
app.component('MazPhoneNumberInput', MazPhoneNumberInput);

app.mount('#app');
